// Ren komposisjons-funksjon for tilbud (offers). Speiler portal/compose.js:
// bygger én standalone HTML med delt /portal/styles.css + litt offer-CSS.
// Faste etiketter kommer fra LABELS (no/en); innholdet skriver admin selv.

const ESC = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
export const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ESC[c]);
const richText = (s) =>
  String(s || "").split(/\n{2,}/).filter(Boolean)
    .map((p) => `<p class="intro reveal">${esc(p).replace(/\n/g, "<br>")}</p>`).join("\n");
const fmtNum = (n, lang) => (Number(n) || 0).toLocaleString(lang === "en" ? "en-GB" : "nb-NO").replace(/ /g, " ");

export function quoteTotal(quote) {
  return ((quote && quote.lines) || []).reduce((s, l) => s + (Number(l.qty) || 0) * (Number(l.unit_price) || 0), 0);
}

// ---- Faste etiketter (chrome) ----
const LABELS = {
  no: {
    htmlLang: "nb", offerWord: "Tilbud", heroEyebrowPrefix: "Tilbud ·",
    heroTitleDefault: "Et skreddersydd tilbud", heroCta: "Til aksept",
    navConcept: "Konsept", navPricing: "Pris", navContract: "Kontrakt", navRider: "Rider", navAccept: "Aksepter",
    conceptEyebrow: "Konsept", pricingEyebrow: "Pris", pricingHeading: 'Tilbudet <span class="accent">deres.</span>',
    qDesc: "Beskrivelse", qQty: "Antall", qUnit: "Enhetspris", qSum: "Sum", qTotal: "Totalt (eks. mva)",
    contractEyebrow: "Kontrakt", contractHeading: "Avtale & vilkår",
    riderEyebrow: "Rider", riderHeading: "Teknisk- og hospitality-rider",
    acceptEyebrow: "Neste steg", acceptH2: "Aksepter tilbudet",
    acceptIntro: "Når dere aksepterer, bekrefter dere tilbudet og vilkårene. Vi bekrefter oppdraget umiddelbart.",
    namePh: "Ditt navn", emailPh: "E-post",
    affirmation: "Jeg bekrefter at jeg har fullmakt til å akseptere dette tilbudet på vegne av kunden, og at aksepten er juridisk bindende.",
    acceptBtn: "Aksepter og signer",
    validUntil: "Gyldig til", declineLink: "Eller takk nei til tilbudet", declineH: "Takk nei",
    declineReasonPh: "Kort begrunnelse (valgfritt)", declineBtn: "Send svar", declineBack: "Avbryt",
    companyPh: "Firma/selskap", rolePh: "Din rolle (f.eks. daglig leder)",
    signatureLabel: "Signér her", clearSig: "Tøm", summaryLabel: "Du aksepterer", summaryTotal: "totalt",
    playLabel: "Spill av",
  },
  en: {
    htmlLang: "en", offerWord: "Offer", heroEyebrowPrefix: "Offer ·",
    heroTitleDefault: "A tailored offer", heroCta: "To acceptance",
    navConcept: "Concept", navPricing: "Pricing", navContract: "Contract", navRider: "Rider", navAccept: "Accept",
    conceptEyebrow: "Concept", pricingEyebrow: "Pricing", pricingHeading: 'Your <span class="accent">offer.</span>',
    qDesc: "Description", qQty: "Qty", qUnit: "Unit price", qSum: "Sum", qTotal: "Total (excl. VAT)",
    contractEyebrow: "Contract", contractHeading: "Agreement & terms",
    riderEyebrow: "Rider", riderHeading: "Technical & hospitality rider",
    acceptEyebrow: "Next step", acceptH2: "Accept the offer",
    acceptIntro: "By accepting, you confirm the offer and its terms. We confirm the booking immediately.",
    namePh: "Your name", emailPh: "Email",
    affirmation: "I confirm that I am authorised to accept this offer on behalf of the client, and that this acceptance is legally binding.",
    acceptBtn: "Accept and sign",
    validUntil: "Valid until", declineLink: "Or decline the offer", declineH: "Decline the offer",
    declineReasonPh: "Brief reason (optional)", declineBtn: "Send reply", declineBack: "Cancel",
    companyPh: "Company", rolePh: "Your role (e.g. managing director)",
    signatureLabel: "Sign here", clearSig: "Clear", summaryLabel: "You are accepting", summaryTotal: "total",
    playLabel: "Play",
  },
};

const FOOTER = `<footer class="foot"><div class="wrap foot-inner">
  <img class="logo" src="/portal/img/77f6b9e8-90df-46da-8a68-f70481f9ad51.png" alt="ROYAL">
  <div class="mantra"><span>Concept</span><i class="sep"></i><span>Creation</span><i class="sep"></i><span>Performance</span><i class="sep"></i><span>Presence</span></div>
  <a class="link" href="https://royal.show" target="_blank" rel="noopener">royal.show <span class="ext">↗</span></a>
</div></footer>`;

const OFFER_CSS = `
.quote { border:1px solid var(--rule); border-radius:12px; overflow:hidden; background:var(--card); }
.quote-row { display:grid; grid-template-columns:1fr 70px 130px 140px; gap:12px; padding:16px clamp(16px,2vw,26px); align-items:center; border-top:1px solid var(--rule-soft); font-size:15px; }
.quote-row:first-child { border-top:none; }
.quote-head { font-size:11px; letter-spacing:0.14em; text-transform:uppercase; color:var(--ink-dimmer); }
.quote-row .num { text-align:right; font-variant-numeric:tabular-nums; }
.quote-total { display:flex; justify-content:space-between; align-items:baseline; padding:20px clamp(16px,2vw,26px); border-top:1px solid var(--rule); background:rgba(255,255,255,0.02); }
.quote-total .label { font-family:var(--font-serif); font-style:italic; font-size:20px; color:var(--ink-dim); }
.quote-total .sum { font-family:var(--font-serif); font-style:italic; font-size:clamp(34px,4vw,54px); color:#ffd5e3; letter-spacing:-0.01em; }
.prose { font-size:clamp(15px,1.1vw,17px); line-height:1.7; color:var(--ink-dim); white-space:pre-wrap; }
.accept { position:relative; border-radius:16px; padding:clamp(28px,3vw,44px); background:linear-gradient(135deg,rgba(255,95,31,.12),rgba(232,25,125,.12)); border:1px solid rgba(232,25,125,.4); }
.accept h2 { font-family:var(--font-serif); font-style:italic; font-size:clamp(26px,3vw,40px); margin-bottom:14px; }
.accept .field { margin-bottom:12px; }
.accept input[type=text], .accept input[type=email] { width:100%; box-sizing:border-box; background:rgba(0,0,0,.3); border:1px solid var(--rule); border-radius:10px; padding:12px 14px; color:var(--ink); font-size:15px; }
.accept label.check { display:flex; gap:10px; align-items:flex-start; font-size:14px; color:var(--ink-dim); cursor:pointer; margin:14px 0; }
.accept .done { font-size:16px; color:#4ade80; }
.sig-wrap { margin:14px 0; }
.sig-pad { width:100%; height:150px; display:block; background:#fff; border:1px solid var(--rule); border-radius:10px; touch-action:none; cursor:crosshair; }
.decline-link { background:none; border:none; color:var(--ink-dim); font-size:13px; text-decoration:underline; cursor:pointer; margin-top:14px; padding:0; display:inline-block; }
.decline-link:hover { color:var(--ink); }
.offer-gallery { display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:clamp(10px,1.4vw,18px); margin-top:28px; }
.offer-gallery img { width:100%; border-radius:14px; display:block; aspect-ratio:4/5; object-fit:cover; }
.offer-split { display:grid; grid-template-columns:1fr 1fr; gap:clamp(24px,3.2vw,52px); align-items:center; }
.offer-split.flip .offer-split-text { order:2; }
.offer-split.flip .offer-split-img { order:1; }
.offer-split-img img { width:100%; border-radius:18px; display:block; }
.offer-split .lead { margin-bottom:14px; }
.offer-audio { width:100%; margin-top:28px; display:block; border-radius:12px; }
.offer-audio::-webkit-media-controls-panel { background:var(--card); }
@media (max-width:680px){
  .quote-row{ grid-template-columns:1fr 40px 76px 84px; gap:6px; font-size:12px; padding-left:14px; padding-right:14px; }
  .quote-head{ font-size:9px; letter-spacing:0.06em; }
  .quote-total{ padding-left:14px; padding-right:14px; }
  .offer-gallery { grid-template-columns:1fr 1fr; }
  .offer-split { grid-template-columns:1fr; gap:22px; }
  .offer-split.flip .offer-split-text, .offer-split.flip .offer-split-img { order:0; }
}
`;

// Video-kort med poster-thumbnail. `poster` = opplastet bilde; mangler det henter offer.js
// thumbnail fra Vimeo/YouTube runtime. Gjenbruker portalens .video-card-stiler.
const videoCard = (url, title, poster, L) => `<div class="video-card reveal" data-video="${esc(url)}" data-title="${esc(title || "Royal")}" style="margin-top:24px">
    ${poster ? `<img src="${esc(poster)}" alt="${esc(title || "")}" loading="lazy">` : ""}
    <span class="play-badge"><span class="tri"></span>${esc((L && L.playLabel) || "Spill av")}</span>
    ${title ? `<div class="video-meta"><span class="label">${esc(title)}</span></div>` : ""}
  </div>`;

const moduleHead = (m, withEyebrowFallback, L) => {
  const eyebrow = m.eyebrow ? esc(m.eyebrow) : (withEyebrowFallback ? esc(L.conceptEyebrow) : "");
  return `<div class="section-head">
      ${eyebrow ? `<div class="eyebrow reveal"><span class="slash">/</span><span>${eyebrow}</span></div>` : ""}
      ${m.title ? `<h2 class="lead reveal">${esc(m.title)}</h2>` : ""}
      ${richText(m.text)}
    </div>`;
};

// Les ut artistene (.crew-card) fra «artister»-seksjonens HTML, for avhuking i builderen.
export function extractArtists(html) {
  if (!html || typeof DOMParser === "undefined") return [];
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return [...doc.querySelectorAll(".crew-card")].map((card) => {
      const first = card.querySelector(".crew-name .first");
      const img = card.querySelector("img");
      const name = ((first && first.textContent) || (img && img.getAttribute("alt")) || "").trim();
      const role = ((card.querySelector(".crew-role") || {}).textContent || "").trim();
      return { name, role };
    }).filter((a) => a.name);
  } catch { return []; }
}

// Behold kun valgte artister i seksjons-HTML-en + renummerer .idx. Tom/uten utvalg => urørt (alle).
function filterArtistsHtml(html, names) {
  if (!html || !Array.isArray(names) || !names.length || typeof DOMParser === "undefined") return html;
  try {
    const set = new Set(names.map((n) => String(n).trim().toLowerCase()));
    const doc = new DOMParser().parseFromString(html, "text/html");
    const cards = [...doc.querySelectorAll(".crew-card")];
    if (!cards.length) return html;
    const nameOf = (card) => {
      const first = card.querySelector(".crew-name .first");
      const img = card.querySelector("img");
      return ((first && first.textContent) || (img && img.getAttribute("alt")) || "").trim().toLowerCase();
    };
    if (!cards.some((c) => set.has(nameOf(c)))) return html;  // utvalget matcher ingen kort -> vis alle (trygghet)
    let kept = 0;
    cards.forEach((card) => {
      if (!set.has(nameOf(card))) { card.remove(); return; }
      const idx = card.querySelector(".idx");
      if (idx) idx.textContent = String(++kept).padStart(2, "0");
    });
    return doc.body.innerHTML;
  } catch { return html; }
}

// Render én modul etter type. sectionMap = { key: {html, html_en} }.
function renderModule(m, i, sectionMap, L, lang) {
  const type = m.type || "image";
  if (type === "section") {
    const sec = sectionMap && sectionMap[m.key];
    if (!sec) return "";
    let html = (lang === "en" && sec.html_en && sec.html_en.trim()) ? sec.html_en : sec.html;
    if (m.key === "artister") html = filterArtistsHtml(html, m.artists);
    return html;
  }
  if (type === "text") {
    return `<section class="section glow" id="mod-${i}"><div class="wrap">${moduleHead(m, false, L)}</div></section>`;
  }
  if (type === "gallery") {
    const imgs = (m.images || []).filter(Boolean).map((u) => `<img src="${esc(u)}" alt="" loading="lazy">`).join("");
    return `<section class="section glow" id="mod-${i}"><div class="wrap">${moduleHead(m, true, L)}<div class="offer-gallery reveal">${imgs}</div></div></section>`;
  }
  if (type === "audio") {
    const player = m.audio_url ? `<audio class="offer-audio reveal" controls preload="none" src="${esc(m.audio_url)}"></audio>` : "";
    return `<section class="section glow" id="mod-${i}"><div class="wrap">${moduleHead(m, true, L)}${player}</div></section>`;
  }
  if (type === "split") {
    const flip = i % 2 === 1 ? " flip" : "";
    const img = m.image_url ? `<div class="offer-split-img reveal"><img src="${esc(m.image_url)}" alt="${esc(m.title || "")}"></div>` : "";
    return `<section class="section glow" id="mod-${i}"><div class="wrap"><div class="offer-split${flip}">
      <div class="offer-split-text">${m.eyebrow ? `<div class="eyebrow reveal"><span class="slash">/</span><span>${esc(m.eyebrow)}</span></div>` : ""}${m.title ? `<h2 class="lead reveal">${esc(m.title)}</h2>` : ""}${richText(m.text)}</div>
      ${img}
    </div></div></section>`;
  }
  // image (default / bakoverkompatibelt)
  // Video-URL satt → vis ett video-kort med (ev.) opplastet bilde som thumbnail.
  if (m.video_url) {
    return `<section class="section glow" id="mod-${i}"><div class="wrap">${moduleHead(m, true, L)}${videoCard(m.video_url, m.title, m.image_url, L)}</div></section>`;
  }
  const img = m.image_url ? `<div class="reveal" style="margin-top:28px"><img src="${esc(m.image_url)}" alt="${esc(m.title || "")}" style="width:100%;border-radius:18px;display:block"></div>` : "";
  return `<section class="section glow" id="mod-${i}"><div class="wrap">${moduleHead(m, true, L)}${img}</div></section>`;
}

function renderModules(modules, sectionMap, L, lang) {
  return (modules || []).map((m, i) => renderModule(m, i, sectionMap, L, lang)).filter(Boolean).join("\n");
}

function renderQuote(quote, L, lang) {
  const lines = (quote && quote.lines) || [];
  if (!lines.length) return "";
  const rows = lines.map((l) => {
    const sum = (Number(l.qty) || 0) * (Number(l.unit_price) || 0);
    return `<div class="quote-row"><div>${esc(l.desc)}</div><div class="num">${esc(l.qty)}</div><div class="num">${fmtNum(l.unit_price, lang)}</div><div class="num">${fmtNum(sum, lang)}</div></div>`;
  }).join("");
  return `<section class="section glow" id="pris"><div class="wrap"><div class="section-head">
      <div class="eyebrow reveal"><span class="slash">/</span><span>${esc(L.pricingEyebrow)}</span></div>
      <h2 class="lead reveal">${L.pricingHeading}</h2>
    </div>
    <div class="quote reveal">
      <div class="quote-row quote-head"><div>${esc(L.qDesc)}</div><div class="num">${esc(L.qQty)}</div><div class="num">${esc(L.qUnit)}</div><div class="num">${esc(L.qSum)}</div></div>
      ${rows}
      <div class="quote-total"><span class="label">${esc(L.qTotal)}</span><span class="sum">${fmtNum(quoteTotal(quote), lang)} <span style="font-size:.4em">NOK</span></span></div>
    </div>
    ${quote.notes ? `<p class="intro reveal" style="margin-top:18px">${esc(quote.notes).replace(/\n/g, "<br>")}</p>` : ""}
  </div></section>`;
}

function proseSection(id, eyebrow, heading, html) {
  if (!html || !html.trim()) return "";
  return `<section class="section glow" id="${id}"><div class="wrap"><div class="section-head">
    <div class="eyebrow reveal"><span class="slash">/</span><span>${esc(eyebrow)}</span></div>
    <h2 class="lead reveal">${esc(heading)}</h2>
  </div><div class="prose reveal">${esc(html)}</div></div></section>`;
}

function acceptBlock(slug, L, { validUntilLabel, title, totalLabel }) {
  const summary = (title || totalLabel) ? `<div style="background:rgba(0,0,0,.25);border:1px solid var(--rule);border-radius:10px;padding:14px 16px;margin-bottom:16px;font-size:14px;line-height:1.5">
        <span style="color:var(--ink-dim)">${esc(L.summaryLabel)}:</span> <strong>${esc(title || "")}</strong>${totalLabel ? ` — ${esc(L.summaryTotal)} <strong>${esc(totalLabel)} NOK</strong>` : ""}${validUntilLabel ? `<br><span style="color:var(--ink-dim)">${esc(L.validUntil)} ${esc(validUntilLabel)}</span>` : ""}
      </div>` : "";
  return `<section class="section" id="aksept"><div class="wrap"><div class="accept reveal" id="accept-box" data-slug="${esc(slug)}">
    <div class="eyebrow"><span class="slash">/</span><span>${esc(L.acceptEyebrow)}</span></div>
    <h2>${esc(L.acceptH2)}</h2>
    <p class="intro" style="margin-bottom:18px">${esc(L.acceptIntro)}</p>
    <div id="accept-form">
      ${summary}
      <div class="field"><input type="text" id="acc-name" placeholder="${esc(L.namePh)}"></div>
      <div class="field"><input type="email" id="acc-email" placeholder="${esc(L.emailPh)}"></div>
      <div class="field"><input type="text" id="acc-company" placeholder="${esc(L.companyPh)}"></div>
      <div class="field"><input type="text" id="acc-role" placeholder="${esc(L.rolePh)}"></div>
      <div class="sig-wrap">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">
          <span style="font-size:12px;color:var(--ink-dim)">${esc(L.signatureLabel)}</span>
          <button type="button" id="sig-clear" class="decline-link" style="margin-top:0">${esc(L.clearSig)}</button>
        </div>
        <canvas id="sig-pad" class="sig-pad"></canvas>
      </div>
      <label class="check"><input type="checkbox" id="acc-agree"> <span id="acc-aff">${esc(L.affirmation)}</span></label>
      <button class="btn btn-primary" id="acc-submit" type="button">${esc(L.acceptBtn)} <span class="arr">→</span></button>
      <div id="acc-msg" style="margin-top:12px;font-size:14px"></div>
      <button class="decline-link" id="decline-toggle" type="button">${esc(L.declineLink)}</button>
    </div>
    <div id="decline-form" style="display:none">
      <h3 style="font-family:var(--font-serif);font-style:italic;font-size:22px;margin-bottom:12px">${esc(L.declineH)}</h3>
      <div class="field"><input type="text" id="dec-name" placeholder="${esc(L.namePh)}"></div>
      <div class="field"><textarea id="dec-reason" placeholder="${esc(L.declineReasonPh)}" style="width:100%;box-sizing:border-box;background:rgba(0,0,0,.3);border:1px solid var(--rule);border-radius:10px;padding:12px 14px;color:var(--ink);font-size:15px;min-height:70px;resize:vertical"></textarea></div>
      <div style="display:flex;gap:12px;align-items:center">
        <button class="btn" id="dec-submit" type="button">${esc(L.declineBtn)}</button>
        <button class="decline-link" id="decline-cancel" type="button">${esc(L.declineBack)}</button>
      </div>
      <div id="dec-msg" style="margin-top:12px;font-size:14px"></div>
    </div>
  </div></div></section>`;
}

export function composeOfferHtml({ slug, customerName, title, eventLabel, modules, concept, quote, contractHtml, riderHtml, sectionMap, language = "no", validUntil, preview = false, presentation = false }) {
  const lang = language === "en" ? "en" : "no";
  const L = LABELS[lang];
  const customer = customerName || "Kunde";
  const validUntilLabel = validUntil ? new Date(validUntil + "T12:00:00").toLocaleDateString(lang === "en" ? "en-GB" : "nb-NO", { day: "numeric", month: "long", year: "numeric" }) : "";
  const mods = modules || concept || [];  // bakoverkompat: gamle tilbud lagret som `concept`
  const hasConcept = mods.some((m) => (m.type || "image") !== "section");

  const nav = `<nav class="nav" id="nav"><a class="nav-brand" href="#top"><img src="/portal/img/77f6b9e8-90df-46da-8a68-f70481f9ad51.png" alt="ROYAL"><span class="x">×</span><span class="partner" data-bind="customer">${esc(customer)}</span></a>
    <div class="nav-links">
      ${hasConcept ? `<a href="#mod-0">${esc(L.navConcept)}</a>` : ""}
      ${(quote && quote.lines && quote.lines.length) ? `<a href="#pris">${esc(L.navPricing)}</a>` : ""}
      ${(contractHtml && contractHtml.trim()) ? `<a href="#kontrakt">${esc(L.navContract)}</a>` : ""}
      ${(riderHtml && riderHtml.trim()) ? `<a href="#rider">${esc(L.navRider)}</a>` : ""}
      ${presentation ? "" : `<a class="nav-cta" href="#aksept">${esc(L.navAccept)}</a>`}
    </div></nav>`;

  const hero = `<header class="hero" id="hero" style="min-height:62vh">
    <div class="hero-bg warm-field"></div>
    <div class="hero-inner wrap">
      <div class="hero-eyebrow eyebrow reveal"><span class="slash">/</span><span>${esc(L.heroEyebrowPrefix)} <span class="partner" data-bind="customer">${esc(customer)}</span></span></div>
      <h1 class="reveal">${esc(title || L.heroTitleDefault)}</h1>
      ${eventLabel ? `<p class="hero-sub reveal">${esc(eventLabel)}</p>` : ""}
      ${presentation ? "" : `<div class="hero-actions reveal"><a class="btn btn-primary" href="#aksept">${esc(L.heroCta)} <span class="arr">↓</span></a></div>`}
    </div>
  </header>`;

  const main = [hero, renderModules(mods, sectionMap, L, lang), renderQuote(quote, L, lang),
    proseSection("kontrakt", L.contractEyebrow, L.contractHeading, contractHtml),
    proseSection("rider", L.riderEyebrow, L.riderHeading, riderHtml),
    presentation ? null : acceptBlock(slug, L, { validUntilLabel, title: title || L.heroTitleDefault, totalLabel: quoteTotal(quote) ? fmtNum(quoteTotal(quote), lang) : "" })].filter(Boolean).join("\n\n");

  return `<!DOCTYPE html>
<html lang="${L.htmlLang}"><head>
<meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">
<title>Royal × ${esc(customer)} · ${esc(L.offerWord)}</title>
<link rel="stylesheet" href="/portal/styles.css">
<style>${OFFER_CSS}</style>
${preview ? '<style>.reveal{opacity:1!important;transform:none!important}</style>' : ''}
</head><body>
${nav}
<main id="top">
${main}
</main>
${FOOTER}
<div class="lightbox" id="lightbox"><button class="lightbox-close" id="lightbox-close" aria-label="Lukk">×</button><div class="lightbox-inner" id="lightbox-inner"></div></div>
<script>window.PORTAL_CONFIG = ${JSON.stringify({ customer, lang })};</script>
<script src="/portal/offer.js"></script>
</body></html>`;
}
